import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  parentChildSettings: {
    display: "flex",
  },
  childCompaniesLabel: {
    marginTop: 16,
    marginBottom: 5,
  },
  loader: {
    display: "block",
    padding: 16,
    color: "inherit",
  },
  hint: {
    marginTop: 16,
    color: theme.palette.grey[500],
    fontStyle: "italic",
  },
}));
